import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/formatDate';
import { 
  Card, CardHeader, CardContent, CardActions, Typography, 
  Chip, List, ListItem, ListItemIcon, ListItemText, Button, 
  Box, Divider
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const MemberSubscriptionPlanItem = ({ plan, editMemberPlan, deleteMemberPlan }) => {
  return (
    <Card
      elevation={2}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        borderLeft: plan.isActive ? '4px solid #4caf50' : '4px solid #9e9e9e'
      }}
    >
      <CardHeader
        title={plan.name}
        action={
          <Chip 
            label={plan.isActive ? 'Active' : 'Inactive'}
            color={plan.isActive ? 'success' : 'default'}
            size="small"
          />
        }
        sx={{
          pb: 1,
          '& .MuiCardHeader-title': {
            fontWeight: 'medium'
          }
        }}
      />
      <CardContent sx={{ flexGrow: 1, pt: 0 }}>
        <Typography variant="h6" color="primary" gutterBottom>
          ${plan.price} for {plan.duration} days
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          {plan.description}
        </Typography>
        
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" gutterBottom>Features:</Typography>
          <List dense disablePadding>
            {plan.features.map((feature, index) => (
              <ListItem key={index} disablePadding sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 28 }}>
                  <CheckCircleIcon fontSize="small" color="success" />
                </ListItemIcon>
                <ListItemText primary={feature} />
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>
      
      <Divider />
      <CardActions sx={{ display: 'flex', justifyContent: 'space-between', p: 2 }}>
        <Typography variant="caption" color="text.secondary">
          Created: {formatDate(plan.createdAt)}
        </Typography>
        <Box>
          <Button
            size="small"
            startIcon={<EditIcon />}
            onClick={() => editMemberPlan(plan)}
            sx={{ mr: 1 }}
          >
            Edit
          </Button>
          <Button
            size="small"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={() => deleteMemberPlan(plan._id)}
          >
            Delete
          </Button>
        </Box>
      </CardActions>
    </Card>
  );
};

MemberSubscriptionPlanItem.propTypes = {
  plan: PropTypes.object.isRequired,
  editMemberPlan: PropTypes.func.isRequired,
  deleteMemberPlan: PropTypes.func.isRequired,
};

export default MemberSubscriptionPlanItem;
